import React, { Component, PureComponent } from 'react';
import EditableTable from "@components/Table/EditableTable";
import { EquipmentChatButton, EquipmentColumns, EquipmentProps } from "@containers/facility/Equipment/EquipmentColumns";
import _ from "lodash";
import actions from "@redux/equipment/actions";
import { connect, useSelector } from "react-redux";
import { api } from "@redux/api";
import { EquipmentFormFields } from "@containers/facility/Equipment/EquipmentFormFields";
import { EquipmentComment } from "@containers/facility/Equipment/EquipmentComment";
import { Button, Drawer, Form, Progress, Tabs } from "antd";
import { CommentOutlined } from "@ant-design/icons";
import FunctionalTesting from "@containers/facility/Equipment/FunctionalTesting/FunctionalTesting";
import SearchLookup from "@components/SearchLookup";
import moment from "moment";
import queryString from "query-string";
import { withRouter } from "@/router/withRouter";
import PermissionControl from "../../../components/Permission/Permission";
import RelatedWorkorder from "@containers/facility/Equipment/RelatedWorkorder/RelatedWorkorder";
import { useAuth, useAuthEditable, useAuthFullAccess } from '@/hooks/use-auth';
import { EventName, useEventBus } from '@/hooks/useEventBus';
import { useSmartNavigate } from '@/hooks/use-smart-navigate';
import { buildFacilityPath, getFacilityContext } from '@/utils/route-context';
import Select from "@components/ResponsiveSelect";
import DatePicker from "@components/ResponsiveDatePicker";

const { TabPane } = Tabs;

const { Option } = Select;

const EQUIPMENT_MOBILE_EXCLUDE_KEYS = [
    "name",
    "id",
    "category",
    "condition",
    "equipment_score",
    "outstanding_workers",
    "modified_date",
    "chat",
    "created_date",
    "modified_date_hidden",
];

const EQUIPMENT_MOBILE_INCLUDE_KEYS = [
    "building",
    "service",
    "recent_workorders_count",
    "description",
    "location",
    "install_date",
    "equipment_age_score",
    "visual_inspection_score",
    "deficiency_score",
    "last_condition_update",
    "recent_functionform",
    "createdby_name",
    "lastModified_name",
];

const formatEquipmentMobileDate = (value) => {
    if (value == null || value === "") return "-";
    const date = moment(value);
    return date.isValid() ? date.format("YYYY-MM-DD") : "-";
};

const formatEquipmentMobileScore = (value) => {
    if (value == null || value === "") return "-";
    const score = Number(value);
    return Number.isFinite(score) ? score.toFixed(1) : "-";
};

const formatEquipmentMobileCondition = (value) => {
    if (value == null || value === "") return "Null";
    return value;
};

const formatEquipmentMobileOutstandingWO = (value) => {
    if (value == null || value === "") return "-";
    return value;
};

const formatEquipmentMobileOutstandingWOPercent = (value) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return 0;
    return Math.max(0, Math.min(100, parsed * 10));
};

const renderEquipmentMobileHeader = (record, navigateToEquipmentDetail) => {
    const equipmentScore = formatEquipmentMobileScore(record.equipment_score);
    const equipmentCondition = formatEquipmentMobileCondition(record.condition);
    const equipmentOutstandingWO = formatEquipmentMobileOutstandingWO(record.outstanding_workers);
    const equipmentOutstandingWOPercent = formatEquipmentMobileOutstandingWOPercent(record.outstanding_workers);
    const equipmentCategory = record.category || "-";
    const handleTitleClick = (event) => {
        event.stopPropagation();
        navigateToEquipmentDetail(record.id);
    };

    return (
    <div className="equipment-mobile-card">
        <div className="equipment-mobile-card-main">
            <span className="equipment-mobile-card-category" title={`Category: ${equipmentCategory}`}>
                {equipmentCategory}
            </span>
            <span
                className="equipment-mobile-card-title equipment-mobile-card-title-link"
                title={record.name || ""}
                onClick={handleTitleClick}
            >
                {record.name || "-"}
            </span>
            <span className="equipment-mobile-card-date">
                {formatEquipmentMobileDate(record.modified_date)}
            </span>
            <span
                className="equipment-mobile-card-chat"
                onClick={(event) => event.stopPropagation()}
            >
                <EquipmentChatButton record={record} />
            </span>
        </div>
        <div className="equipment-mobile-card-metrics">
            <span className="equipment-mobile-card-metric" title={`Equipment Score: ${equipmentScore}`}>
                <span className="equipment-mobile-card-metric-label">Score</span>
                <span className="equipment-mobile-card-metric-value">{equipmentScore}</span>
            </span>
            <span className="equipment-mobile-card-metric" title={`Condition: ${equipmentCondition}`}>
                <span className="equipment-mobile-card-metric-label">Cond</span>
                <span className="equipment-mobile-card-metric-value">{equipmentCondition}</span>
            </span>
            <span className="equipment-mobile-card-metric equipment-mobile-card-metric-wo" title={`Outstanding WO: ${equipmentOutstandingWO}`}>
                <span className="equipment-mobile-card-metric-label">WO</span>
                <Progress
                    className="equipment-mobile-card-wo-progress"
                    percent={equipmentOutstandingWOPercent}
                    steps={5}
                    showInfo={false}
                    strokeColor={["#f59e0b", "#f59e0b", "#f59e0b", "#f59e0b", "#f59e0b"]}
                />
            </span>
        </div>
    </div>
    );
};

class Equipment extends PureComponent {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.filterFormRef = React.createRef();
        this.state = {
            data: [],
            name: '',
            description: '',
            condition: '',
            building: '',
            location: '',
            category: '',
            service: '',
            Equipment_Model: '',
            Equipment_SN: '',
            isLoading: false,
            query: null,
            selectedRecord: null,
            install_date: [null, null],
            created_date: [null, null],
            modify_date: [null, null],
            name_keyword: '',
            description_keyword: '',
            location_keyword: '',
            service_keyword: '',
            building_keyword: '',
            Equipment_Model_keyword: '',
            Equipment_SN_keyword: '',
            category_keyword: '',
            selectedTab: '1',
            eq_id: '',
            commentDrawerOpen: false,
            commentEquipmentId: null,
        }
    }

    componentDidMount() {
        const params = queryString.parse(this.props.location.search);
        console.log('params', params)
        if (params?.condition) {
            this.setState({
                condition: params.condition
            })
        }
        if (params?.category) {
            this.setState({
                category: params.category
            })
        }
        if (params?.id) {
            this.setState({
                eq_id: params.id
            })
        }
    }

    componentDidUpdate(prevProps) {
        // Listen for refreshKey change to refresh table
        if (prevProps.refreshKey !== this.props.refreshKey && this.props.refreshKey > 0) {
            if (this.tableRef && this.tableRef.current) {
                this.tableRef.current.refresh();
            }
        }
    }

    handleCreateEquipment = (body) => {
        return api.createEquipment(body).then(
            response => {
                // console.log('create', response);
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleDeleteEquipment = (id) => {
        return api.deleteEquipment(id).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleBulkInsert = (body) => {
        return api.bulkEquipmentInsert(body).then(
            response => {
                return response.data
            }
        ).catch(error => {
            return (
                error
            )
        });
    }

    handleBulkDelete = (body) => {
        return api.bulkDeleteEquipment(body).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handOnlineSave = (key, row) => {
        return api.editEquipment(key, row).then(
            response => {

                return response
            }
        ).catch(error => (
            error
        ));
    }


    handleFilter = (query) => {


        this.setState({
            isLoading: true,
        });

        let query_new = query +
            (this.state.eq_id ? ('&id=' + (this.state.eq_id)) : '') +
            (this.state.name ? ('&name=' + (this.state.name)) : '') +
            (this.state.description ? ('&description=' + (this.state.description)) : '') +
            (this.state.condition ? ('&condition=' + (this.state.condition)) : '') +
            (this.state.building ? ('&building=' + (this.state.building)) : '') +
            (this.state.category ? ('&category=' + (this.state.category)) : '') +
            (this.state.location ? ('&location=' + (this.state.location)) : '') +
            (this.state.service ? ('&service=' + (this.state.service)) : '') +
            (this.state.Equipment_Model ? ('&Equipment_Model=' + (this.state.Equipment_Model)) : '') +
            (this.state.Equipment_SN ? ('&Equipment_SN=' + (this.state.Equipment_SN)) : '') +
            (this.state.install_date[0] ? ('&install_date_start=' + (moment(this.state.install_date[0]).format('YYYY-MM-DD'))) : '') +
            (this.state.install_date[1] ? ('&install_date_end=' + (moment(this.state.install_date[1]).format('YYYY-MM-DD'))) : '') +
            (this.state.created_date[0] ? ('&created_date_start=' + (moment(this.state.created_date[0]).format('YYYY-MM-DD'))) : '') +
            (this.state.created_date[1] ? ('&created_date_end=' + (moment(this.state.created_date[1]).format('YYYY-MM-DD'))) : '') +
            (this.state.modify_date[0] ? ('&modify_date_start=' + (moment(this.state.modify_date[0]).format('YYYY-MM-DD'))) : '') +
            (this.state.modify_date[1] ? ('&modify_date_end=' + (moment(this.state.modify_date[1]).format('YYYY-MM-DD'))) : '')


        return api.filterEquipment(query_new).then(
            response => {
                let dataSource = response.data.results
                return {
                    data: dataSource,
                    success: true,
                    total: response.data.count
                }
            }
        ).catch(error => (
            error
        ));
    }

    getEquipment = (data) => {

        this.setState({
            isLoading: false,
            data
        })

        this.props.setEquipmentSuccess(data)
    }

    EquipmentRelated = (relatedId) => {
        return <>{relatedId ?
            <RelatedWorkorder relatedList={true} relatedId={relatedId} parentEquipment={relatedId} relatedObject={'equipment'} /> : ''}</>
    }

    handlePostComment = (e) => {

        return <EquipmentComment id={e} />
    }

    openMobileCommentDrawer = (record) => {
        this.setState({
            commentDrawerOpen: true,
            commentEquipmentId: record?.id || null,
        });
    }

    closeMobileCommentDrawer = () => {
        this.setState({
            commentDrawerOpen: false,
            commentEquipmentId: null,
        });
    }

    renderMobileRowActions = (record) => {
        return [
            <Button
                key="mobile-comments"
                size="small"
                icon={<CommentOutlined />}
                onClick={() => this.openMobileCommentDrawer(record)}
            >
                Comments
            </Button>
        ];
    }


    refresh = (needRequest) => {
        return this.tableRef?.current?.refresh(needRequest);
    };

    onNew = () => {
        this.props.navigate(this.props.createEquipmentPath);
    };

    handleLookupFilter = (e) => {

        let query_new = (this.state.name_keyword ? ('name=' + this.state.name_keyword) : '') +
            (this.state.description_keyword ? ('description=' + this.state.description_keyword) : '') +
            (this.state.location_keyword ? ('location=' + this.state.location_keyword) : '') +
            (this.state.category_keyword ? ('category=' + this.state.category_keyword) : '') +
            (this.state.service_keyword ? ('service=' + this.state.service_keyword) : '') +
            (this.state.Equipment_Model_keyword ? ('Equipment_Model=' + this.state.Equipment_Model_keyword) : '') +
            (this.state.Equipment_SN_keyword ? ('Equipment_SN=' + this.state.Equipment_SN_keyword) : '') +
            (this.state.building_keyword ? ('building=' + this.state.building_keyword) : '') +
            '&page_size=50';

        return api
            .filterEquipment(query_new)
            .then((response) => {
                let dataSource = response.data.results;
                return {
                    data: dataSource,
                    success: true,
                    total: response.data.count,
                };
            })
            .catch((error) => {
                return error;
            });
    }

    handleSelect = (e, type) => {
        this.setState({
            [type]: e,
            limit: null
        }, function () {
            this.refresh(false);
        })
    }

    handleSearchSelect = (e, type) => {
        this.setState({
            [type]: e,
            limit: null
        }, function () {
            this.refresh(false);
        })
    }

    handleSearch = (e, type) => {
        this.setState({
            [type + '_keyword']: e
        });
        return this.handleLookupFilter();
    }

    onDateChange = (dates, state) => {
        this.setState({
            [state]: dates ?? []
        }, function () {
            this.refresh(false);
        })

    }

    renderFilter = () => {
        return <SearchLookup
            placeholder={'name'}
            name={'name'}

            SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'name')}
            Lookup_CommonupRequest={(e) => this.handleSearch(e, 'name')}
        />
    }

    resetFilters = () => {
        this.filterFormRef.current.resetFields();
        this.setState({
            name: '',
            description: '',
            condition: '',
            building: '',
            location: '',
            category: '',
            service: '',
            Equipment_Model: '',
            Equipment_SN: '',
            install_date: [null, null],
            created_date: [null, null],
            modify_date: [null, null]
        }, function () {
            this.refresh(false)
        })

    }
    renderSearches = () => {

        return (
            <Form ref={this.filterFormRef} className={'filter-form'} autoComplete="off">
                <Form.Item label={'Name'} name="name">
                    <SearchLookup
                        placeholder={'name'}
                        name={'name'}
                        SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'name')}
                        Lookup_CommonupRequest={(e) => this.handleSearch(e, 'name')}
                    />
                </Form.Item>

                <Form.Item label={'Description'} name="description">
                    <SearchLookup
                        placeholder={'description'}
                        name={'description'}
                        SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'description')}
                        Lookup_CommonupRequest={(e) => this.handleSearch(e, 'description')}
                    />
                </Form.Item>

                <Form.Item label={'Location'} name="location">
                    <SearchLookup
                        placeholder={'location'}
                        name={'location'}
                        SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'location')}
                        Lookup_CommonupRequest={(e) => this.handleSearch(e, 'location')}
                    />
                </Form.Item>

                <Form.Item label={'Building'} name={'building'}>
                    <SearchLookup
                        placeholder={'building'}
                        name={'building'}
                        SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'building')}
                        Lookup_CommonupRequest={(e) => this.handleSearch(e, 'building')}
                    />
                </Form.Item>

                <Form.Item label={'Service'} name={'service'}>
                    <SearchLookup
                        placeholder={'service'}
                        name={'service'}
                        SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'service')}
                        Lookup_CommonupRequest={(e) => this.handleSearch(e, 'service')}
                    />
                </Form.Item>

                <Form.Item label={'Category'} name={'category'}>
                    <SearchLookup
                        placeholder={'category'}
                        name={'category'}
                        defaultValue={this.state.category}
                        SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'category')}
                        Lookup_CommonupRequest={(e) => this.handleSearch(e, 'category')}
                    />
                </Form.Item>

                <Form.Item label={'Equipment Model'} name={'Equipment_Model'}>
                    <SearchLookup
                        placeholder={'Equipment Model'}
                        name={'Equipment_Model'}
                        SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'Equipment_Model')}
                        Lookup_CommonupRequest={(e) => this.handleSearch(e, 'Equipment_Model')}
                    />
                </Form.Item>

                <Form.Item label={'Equipment SN'} name={'Equipment_SN'}>
                    <SearchLookup
                        placeholder={'Equipment SN'}
                        name={'Equipment_SN'}
                        SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'Equipment_SN')}
                        Lookup_CommonupRequest={(e) => this.handleSearch(e, 'Equipment_SN')}
                    />
                </Form.Item>

                <Form.Item label={'Condition'} name={'condition'}>
                    <Select className={'w-full'} placeholder={'condition'} value={this.state.condition} name={'condition'}
                        onChange={(e) => this.handleSearchSelect(e, 'condition')}>
                        <Option value=""></Option>
                        <Option value="Null">Null</Option>
                        <Option value="Excellent">Excellent</Option>
                        <Option value="Good">Good</Option>
                        <Option value="Fair">Fair</Option>
                        <Option value="Poor">Poor</Option>
                        <Option value="Failed">Failed</Option>
                    </Select>
                </Form.Item>

                <Form.Item name={'install_date_start'} label={'Install Date'}>
                    <DatePicker.RangePicker
                        name={'install_date_start'}
                        className={'border-right-6'}
                        value={this.state.install_date}
                        onChange={(dates) => this.onDateChange(dates, 'install_date')}
                    />
                </Form.Item>

                <Form.Item name={'created_date_start'} label={'Created Date'}>
                    <DatePicker.RangePicker
                        value={this.state.created_date}
                        onChange={(dates) => this.onDateChange(dates, 'created_date')}
                    />
                </Form.Item>

                <Form.Item name={'modify_date'} label={'Modified Date'}>
                    <DatePicker.RangePicker
                        value={this.state.modify_date}
                        onChange={(dates) => this.onDateChange(dates, 'modify_date')}
                    />
                </Form.Item>

                {/* <Form.Item name={'install_date_end'} label={'Install Date End'}>
                    <DatePicker
                        name={'install_date_end'}
                        className={'border-left-6'}
                        value={this.state.install_date[1]}
                        placeholder={'install end date'}
                        onChange={(dates) => this.onDateChange(dates, 'install_date', 1, '')}
                    />
                </Form.Item> */}

            </Form>
        )
    }

    renderAdditionalForm = (data) => {
        console.log('record: ', data)
        return (
            <>{data && <FunctionalTesting selectedRecord={data} />}</>
        )
    }

    handleSelectedRecord = (record) => {
        this.setState({
            selectedRecord: record
        })
    }

    handleTab = (key) => {
        this.setState({
            selectedTab: key
        })
    }

    render() {
        return (

            <div className={'p-5'}>
                <EditableTable
                    ref={this.tableRef}
                    columns={EquipmentColumns(this.handleSelectedRecord)}
                    data={this.state.data}
                    columnProps={EquipmentProps}
                    formFields={EquipmentFormFields}
                    formRelated={this.EquipmentRelated}
                    getRecord={this.getEquipment}
                    createRecords={this.handleCreateEquipment}
                    deleteRecord={this.handleDeleteEquipment}
                    bulkInsert={this.handleBulkInsert}
                    bulkDelete={this.handleBulkDelete}
                    handOnlineSave={this.handOnlineSave}
                    handleFilter={this.handleFilter}
                    postComment={this.handlePostComment}
                    renderFilter={this.renderFilter}
                    resetFilters={this.resetFilters}
                    relatedList={this.props.relatedList}

                    hide_search={true}
                    isRowClickable={false}
                    // isChat={true}
                    isRelated={true}
                    isAttachments={true}

                    setFilters={this.setFilters}
                    formClassName={'flex-form'}
                    filterDescription={this.state.filterDescription}

                    renderSearches={this.renderSearches}

                    renderAdditionalForm={this.renderAdditionalForm}
                    isAdditionalForm={true}
                    new_text={'Create Equipment'}
                    onNew={this.onNew}
                    hid_new={!this.props.editable}
                    hide_imports={!this.props.editable}
                    canDelete={this.props.fullAccess}
                    mobileCardHeaderRender={(record) => renderEquipmentMobileHeader(record, this.props.navigateToEquipmentDetail)}
                    mobileRowActions={this.renderMobileRowActions}
                    mobileExpandedExcludeKeys={EQUIPMENT_MOBILE_EXCLUDE_KEYS}
                    mobileExpandedIncludeKeys={EQUIPMENT_MOBILE_INCLUDE_KEYS}
                    mobileInfiniteScroll={true}
                    mobilePageSize={24}
                    defaultDisplayColumns={{
                        "id": {
                            "show": false
                        },
                        "description": {
                            "show": false
                        },
                        "location": {
                            "show": false
                        },
                        "install_date": {
                            "show": false
                        },
                        "equipment_age_score": {
                            "show": false
                        },
                        "visual_inspection_score": {
                            "show": false
                        },
                        "deficiency_score": {
                            "show": false
                        },
                        "last_condition_update": {
                            "show": false
                        },
                        "recent_functionform": {
                            "show": false
                        },
                        "createdby_name": {
                            "show": false
                        },
                        "lastModified_name": {
                            "show": false
                        }
                    }}
                />
                <Drawer
                    title="Comments"
                    placement="bottom"
                    height="85vh"
                    open={this.state.commentDrawerOpen}
                    onClose={this.closeMobileCommentDrawer}
                    destroyOnClose={true}
                    className="equipment-comment-mobile-drawer"
                    bodyStyle={{ padding: 0 }}
                >
                    <EquipmentComment
                        id={this.state.commentEquipmentId}
                        boxHeight="calc(85vh - 56px)"
                    />
                </Drawer>

            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        Equipment: _.get(state.Equipment, 'data'),
    }
}
const mapDispatchToProps = dispatch => {
    return {

        setEquipmentRequest: (e) => dispatch(actions.EquipmentRequest(e)),
        setEquipmentSuccess: (e) => dispatch(actions.EquipmentSuccess(e)),
    }
}

const withHooks = (Component) => {
    const NewComponent = (props) => {
        const editable = useAuthEditable('equipment');
        const fullAccess = useAuthFullAccess('equipment')
        const { navigateToEquipmentDetail } = useSmartNavigate();
        const facilityContext = useSelector((state) => getFacilityContext(state));
        const createEquipmentPath = buildFacilityPath('create-equipment', facilityContext) || '/switch-view';

        const [refreshKey, setRefreshKey] = React.useState(0);

        useEventBus(EventName.REFRESH_EQUIPMENT_LIST, () => {
            setRefreshKey(prev => prev + 1);
        });

        return <Component {...props} editable={editable} fullAccess={fullAccess} refreshKey={refreshKey} createEquipmentPath={createEquipmentPath} navigateToEquipmentDetail={navigateToEquipmentDetail} />
    }
    return NewComponent;
}

export default withHooks(withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Equipment)));
